import React, { useEffect } from "react";
import { IconButton, Badge, Box, useMediaQuery, useTheme } from "@mui/material";
import { Notifications as NotificationsIcon } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchNotificationsRequest,
  openNotificationModal,
} from "../../../redux/notifications/actions";

const NotificationIcon = () => {
  const dispatch = useDispatch();
  const { notifications, totalunreadcount } = useSelector(
    (state) => state.notification
  );

  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    dispatch(
      fetchNotificationsRequest({
        pageNo: 1,
        pageSize: 5,
        paginationRequired: false,
      })
    );

    const intervalId = setInterval(() => {
      dispatch(
        fetchNotificationsRequest({
          pageNo: 1,
          pageSize: 5,
          paginationRequired: false,
        })
      );
    }, 5 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, [dispatch]);

  const unreadCount = totalunreadcount;

  const handleNotificationClick = () => {
    dispatch(
      fetchNotificationsRequest({
        pageNo: 1,
        pageSize: 5,
        paginationRequired: true,
      })
    );
    dispatch(openNotificationModal());
  };

  return (
    <Box
      sx={{
        mx: isXsScreen ? 0.5 : 2,
        display: "flex",
        alignItems: "center",
      }}
    >
      <IconButton
        onClick={handleNotificationClick}
        size={isXsScreen ? "small" : "medium"}
        aria-label={`${unreadCount} unread notifications`}
        sx={{
          color: "#ed6c02",
          "&:hover": {
            bgcolor: "rgba(237, 108, 2, 0.08)",
          },
        }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          sx={{
            "& .MuiBadge-badge": {
              fontSize: "0.7rem",
              minWidth: "18px",
              height: "18px",
            },
          }}
        >
          <NotificationsIcon fontSize={isXsScreen ? "small" : "medium"} />
        </Badge>
      </IconButton>
    </Box>
  );
};

export default NotificationIcon;
